import CardShowPodium from '../clubpoints/cardShowPodium'
export const ContactResultCard = ({ record, ...props }) => (
	props.resource = 'results',
	props.basePath = '/results',
	props.id = record.Results[0].ResultId,
	props.record = record.Results[0],
	<CardShowPodium key={record.ResultId} {...props}/>
)
export default ContactResultCard